<template>
  <div>
    <CHeader class="bg-dark position-relative">
      <div class="mt-2"  style="margin: 0 12%;">
        <div style="width:200px !important;">
          <img :src="companyLogo"
            block
            class="w-100 h-100"
          />
        </div>
      </div>
    </CHeader>
    <div style="margin: 0 12%;">
      <CAlert 
        class="w-50 mx-auto mt-5 fixed-top"
        :color="alert.color" 
        :closeButton="typeof(alert.show) !== 'number'" 
        :show.sync="alert.show"
        @update:show="(value)=> alertEvent(value)">
        {{ alert.message }}
        <CProgress v-if="typeof(alert.show) == 'number'"
          animate
          height="3px"
          class="my-3"
          :value="alert.show"
          :color="alert.color"
          :max="5"
        />         
      </CAlert>
          
      <CCard class="mt-5">
        <CCardHeader>
          <h2>Solicitud de Garantía</h2>
        </CCardHeader>
        <CCardBody>
          <CTabs>
            <CTab title="Nueva Solicitud">
              <CForm class="mt-3 mx-4">
                <h4 class="my-3">Empresa</h4>
                <CRow>
                  <CCol sm="4" >
                    <CInput
                      label="Identificación: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.id"
                      :isValid="warrantyRequest.id.length > 0"
                      @blur="() => {                                            
                          validate()
                      }"
                    />
                  </CCol>
                </CRow>

                <h4 class="my-3">Datos del Producto</h4>
                <CRow>
                  <CCol col="3" sm="3">
                    <CSelect
                      label="Tipo Producto: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.productType"
                      @input="(value) => {                                
                        if(value === 'E'){
                          warrantyRequest.qty = 1
                        }
                        warrantyRequest.code = ''
                        warrantyRequest.serialNumber = ''
                        validate()
                      }"
                      :options="[
                        {value: 'C', label: 'Computo'},
                        {value: 'I', label: 'Impresión'},
                        {value: 'A', label: 'Accesorios'},
                        {value: 'S', label: 'Suministros'},
                        {value: 'O', label: 'Otros'},
                      ]"
                    />
                  </CCol>

                  <CCol sm="1" >
                    <CInput
                      label="Cantidad: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.qty"
                      :disabled="warrantyRequest.productType === 'C' || (warrantyRequest.productType === 'I')"
                      @blur="validate()"
                    />
                  </CCol>
                  <CCol col="3" sm="3" v-if="warrantyRequest.productType === 'C' || (warrantyRequest.productType === 'I')">
                    <CInput
                      label="Número Serial: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.serialNumber"
                      :isValid="warrantyRequest.productType === 'C' || (warrantyRequest.productType === 'I') ? warrantyRequest.serialNumber.length > 0 : null"
                      :disabled="parseInt(warrantyRequest.qty) > 1"
                      @blur="validate()"
                    />
                  </CCol>
                  <CCol col="3" sm="3" v-if="warrantyRequest.productType !== 'C' && (warrantyRequest.productType !== 'I')">
                    <CInput
                      label="Código: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.code"
                      :isValid="warrantyRequest.productType !== 'E' && (warrantyRequest.productType !== 'I') ? warrantyRequest.code.length > 0 : null"
                      @blur="validate()"
                    />
                  </CCol>
                  <CCol col="2" sm="2" v-if="warrantyRequest.productType !== 'C' && (warrantyRequest.productType !== 'I')">
                    <CInput
                      label="Prefijo: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.billPrefix"
                      @input="() => {                                
                          
                      }"
                      @blur="() => {                                            
                          validate()
                      }"
                    />
                  </CCol>
                  <CCol col="3" sm="3" v-if="warrantyRequest.productType !== 'C' && (warrantyRequest.productType !== 'I')">
                    <CInput
                      label="Número: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.billNumber"
                      :isValid="warrantyRequest.billNumber.length > 0"
                      @blur="() => {                                            
                          validate()
                      }"
                    />
                  </CCol>
                  <CCol sm="12" >
                    <CTextarea
                      label="Observaciones: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.observations"
                      :isValid="warrantyRequest.observations.length > 0"
                      @blur="validate()"
                    />
                  </CCol>
                  <CCol sm="12">
                    <label class="text-muted font-weight-bold" for="">Archivo Adjunto:</label>
                    <CInputFile
                      label="Archivo Adjunto: "
                      addInputClasses="col-sm-12"
                      addLabelClasses="text-muted font-weight-bold"
                      :vertical="true"
                      :custom="true" 
                      @change="(files) => checkFileSize(files)"
                    />
                  </CCol>
                </CRow>

                <h4 class="mt-4">Datos de Contacto</h4>
                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Persona de Contacto:"
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.name"
                      :isValid="warrantyRequest.name.length > 0"
                      @blur="validate()"
                    />
                  </CCol>
                  <CCol col="6" sm="6">
                    <CInput
                      label="Correo Electrónico: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.email"
                      :isValid="warrantyRequest.email.length > 0"
                      @blur="validate()"
                    />
                  </CCol>
                  <CCol col="4" sm="4">
                    <CInput
                      label="Teléfono: "
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="warrantyRequest.tel"
                      :isValid="warrantyRequest.tel.length > 0"
                      @blur="validate()"
                    />
                  </CCol>
                </CRow>                            

                <CRow class="d-flex justify-content-center mt-3">
                  <CButton
                    class="mr-2 d-inline-block"
                    color="primary"
                    :class="isValidForm ? '' : 'disabled'"
                    :disabled="!isValidForm"
                    @click="createWarrantyRequest()">
                    <CIcon name="cil-check-alt"/>
                    <span class="align-middle mx-2">Enviar</span>
                  </CButton>
                  <CButton
                    class="mr-2 d-inline-block"
                    color="secondary"
                    variant="outline"
                    @click="clear">
                    <CIcon name="cil-x"/>
                    <span class="align-middle mx-2">Limpiar</span>
                  </CButton>
                </CRow>
              </CForm>
            </CTab>

            <CTab title="Consulta">
              <CForm class="mt-3">
                <CCol sm="2" >
                  <CInput
                    label="Prefijo Garantía: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="warrantyQuery.prefix"                                    
                    @blur="validateQuery()"
                  />
                </CCol>
                <CCol sm="4" >
                  <CInput
                    label="Número Garantía: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="warrantyQuery.number"                                    
                    @blur="validateQuery()"
                  />
                </CCol>
                <CCol sm="4" >
                  <CInput
                    label="Clave Seguridad: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="warrantyQuery.hash"                                    
                    @blur="validateQuery()"
                  />
                </CCol>
                <CButton :class="isValidQueryForm ? '' : 'disabled'" :disabled="!isValidQueryForm" @click="getWarrantyInfo()">
                    <CIcon class="text-info" name="cil-reload"/>
                </CButton>
              </CForm>

              <CRow class="d-flex justify-content-center mt-3">                                
                <CButton
                  color="secondary"
                  class="mr-2 d-inline-block"
                  @click="clearQuery()">
                  <CIcon name="cil-x"/>
                  <span class="align-middle mr-2">Limpiar</span>
                </CButton>
              </CRow>

              <CRow v-if="warrantyInfo.numero">
                <CContainer class="mt-5 d-flex mx-auto">
                  <CCol sm="6" >
                    <div class="ml-4"><strong>Número:</strong> {{warrantyInfo.numero}}</div>
                    <div class="ml-4"><strong>Factura: {{warrantyInfo.prefijo_Factura}} </strong>{{warrantyInfo.numero_Factura}}</div>
                    <div class="ml-4"><strong>Fecha Factura: </strong>{{moment(warrantyInfo.fecha_Factura).format('DD/MM/YYYY')}}</div>
                    <div class="ml-4"><strong>Código Producto: </strong>{{warrantyInfo.codigo_Producto}}</div>
                    <div class="ml-4"><strong>Descripción: </strong>{{warrantyInfo.descripcion_Producto}}</div>
                    <div class="ml-4"><strong>Serial: </strong>{{warrantyInfo.numero_Serial}}</div>
                    <div class="ml-4"><strong>Cantidad: </strong>{{warrantyInfo.cantidad}}</div>
                    <div class="ml-4"><strong>Observaciones: </strong>{{warrantyInfo.observaciones}}</div>
                    <div class="ml-4"><strong>Fecha Radicación:</strong> {{moment(warrantyInfo.fecha_Creacion).format('DD/MM/YYYY HH:mm:ss')}}</div>
                    <div class="ml-4"><strong>Fecha Actualización:</strong> {{moment(warrantyInfo.fecha_Actualizacion).format('DD/MM/YYYY HH:mm:ss')}}</div>
                    <div class="ml-4"><strong>Estado:</strong> {{warrantyStatus[warrantyInfo.estado]}}</div>
                  </CCol>
                  <CCol sm="6" >
                    <div class="ml-4"><strong>Empresa: </strong>{{warrantyInfo.nombre_Empresa}}</div>
                    <div class="ml-4"><strong>Identificación: </strong>{{warrantyInfo.identificacion_Empresa}}</div>
                    <div class="ml-4"><strong>Contacto:</strong>{{warrantyInfo.nombre_Contacto}}</div>
                    <div class="ml-4"><strong>Telefono:</strong>{{warrantyInfo.telefono_Contacto}}</div>
                    <div class="ml-4"><strong>Correo:</strong>{{warrantyInfo.correo_Contacto}}</div>
                  </CCol>
                </CContainer>

                <CDataTable
                  class="mt-5 mx-5 w-100"
                  :fields="fieldsDetail"
                  :items="warrantyInfo.seguimientos"
                  :items-per-page="10">
                  <template #estado_Garantia="{item}">
                    <td>
                      {{warrantyStatus[item.estado_Garantia]}}
                    </td>
                  </template>
                  <template #fecha="{item}">
                    <td class="text-start">
                      {{ moment(item.fecha).format('DD/MM/YYYY') }}
                    </td>
                  </template>
                  <template #fecha_Creacion="{item}">
                    <td class="text-start">
                      {{ moment(item.fecha_Creacion).format('DD/MM/YYYY HH:mm:ss') }}
                    </td>
                  </template>
                  <template #nombre_ArchivoAdjunto="{item}">
                    <td class="text-center">
                      <CButton v-if="item.nombre_ArchivoAdjunto" :to="item.nombre_ArchivoAdjunto">
                        <CIcon class="text-info" name="cil-paperclip"/>
                      </CButton>
                    </td>
                  </template>
                </CDataTable>
              </CRow>
            </CTab>
          </CTabs>
        </CCardBody>
      </CCard>

      <CElementCover  v-show="loading"/>
    </div>
  </div>
</template>
<script>
  import moment from "moment";
  import {
    getCompanyLogo, 
    errorMessage,
    toBase64
  } from "@/general";
  import {
    grabaGarantiaCliente, 
    consultaGarantiaCliente
  } from "@/api";

  const fieldsDetail = [
    { 
      key: "nombre_ArchivoAdjunto", 
      label: "",
      _style:"text-align:center;"
    },   
    { 
      key: "fecha",
      label: "Fecha",
      _style:"text-align:center;"
    },
    { 
      key: "estado_Garantia",
      label: "Estado",
      _style:"text-align:center;"
    },
    { 
      key: "observaciones", 
      label: "Observaciones",
      _style:"text-align:center;"
    },
    { 
      key: "fecha_Creacion", 
      label: "Fecha Creación",
      _style:"text-align:center;"
    }
  ]

  export default {
    data() {
      return {
        fieldsDetail,
        warrantyRequest: {
          id: "",
          billPrefix: "",
          billNumber: "",
          product: "",
          qty: 1,
          serialNumber: "",
          attachmentFile: "",
          observations: "",
          code: "",
          productType: "C",
          name: "",
          tel: "",
          email: ""
        },
        warrantyQuery: {
          prefix: "",
          number: "",
          hash: ""
        },
        warrantyInfo:{},
        loading: false,
        isValidForm: false,
        isValidQueryForm: false,
        companyLogo: "",
        warrantyStatus: {
          "RAD": "Radicada", 
          "PRE": "Producto Recibido", 
          "REV": "Revision", 
          "PRO": "En Proceso",
          "PEN": "Producto para Entrega",
          "FIN": "Finalizada",
          "REC": "Rechazada",
        }
      }  
    },
    methods: {
      moment,
      validate() {
        this.isValidForm = 
          this.warrantyRequest.id.length > 0 && 
          (this.warrantyRequest.productType !== "C" && (this.warrantyRequest.productType !== "I") ? this.warrantyRequest.billNumber.length > 0 : true) && 
          (this.warrantyRequest.observations.length > 0) && 
          (this.warrantyRequest.name.length > 0) && 
          (this.warrantyRequest.tel.length > 0) && 
          (this.warrantyRequest.email.length > 0) && 
          (this.warrantyRequest.productType === "C" || (this.warrantyRequest.productType === "I") ? this.warrantyRequest.serialNumber.length > 0 : this.warrantyRequest.code.length > 0)
      },
      validateQuery() {
        this.isValidQueryForm = this.warrantyQuery.number.length > 0 && (this.warrantyQuery.hash.length > 0)
      },
      async createWarrantyRequest(){
        try {
          this.loading = true
          const attachmentFile = await toBase64(this.warrantyRequest.attachmentFile)
          
          await grabaGarantiaCliente(
            this,
            this.warrantyRequest.id,
            this.warrantyRequest.billPrefix,
            this.warrantyRequest.billNumber,
            this.warrantyRequest.productType,
            this.warrantyRequest.qty,
            this.warrantyRequest.code,
            this.warrantyRequest.serialNumber,
            this.warrantyRequest.observations,
            this.warrantyRequest.name,
            this.warrantyRequest.tel,
            this.warrantyRequest.email,
            this.fileNameAttachment,
            attachmentFile
          )
          this.$store.commit(
            "setAlert",
            { 
              color: "success",
              message: "Acción exitosa",
              show: 5 
            }
          )

          this.$router.push({ path: '/'});
        } catch(error) {
          console.log(error)
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      async getWarrantyInfo(){
        this.loading = true;

        try{
          const {response} = await consultaGarantiaCliente(this, this.warrantyQuery.prefix, this.warrantyQuery.number, this.warrantyQuery.hash);

          this.warrantyInfo = response;
        } catch(error){
          console.log(error)
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5 
          });
        } finally {
          this.loading = false
        }
      },
      clear() {
        Object.keys(this.warrantyRequest).forEach(key => {
          if (key === "qty") {
            this.warrantyRequest[key] = 1
          } else if (key === "productType") {
            this.warrantyRequest[key] = "C"
          } else {
            this.warrantyRequest[key] = ""
          }
        });
      },
      clearQuery(){
        Object.keys(this.warrantyQuery).forEach(key => {
          this.warrantyQuery[key] = ""
        })
        this.warrantyInfo = {}
      },
      alertEvent(value){
        if (typeof(value) == "boolean") {    
          this.$store.commit("setAlert", { show: false })
        } else {      
          if (!value) {
            this.$store.commit("setAlert", { show: false })
          }
        }
      },
      checkFileSize(files) {
        if (files[0].size/1024/1204 > 5) {
          this.$store.commit("setAlert", { 
              color: "warning", 
              message: "El tamaño del archivo no puede ser de más de 5MB",
              show: 5
            });

            return;
          }

        this.warrantyRequest.attachmentFile = files;
      }
    },
    computed: {
      alert() {
        return this.$store.state.alert
      },
      fileNameAttachment() {
        if (this.warrantyRequest.attachmentFile[0]) {
          return this.warrantyRequest.attachmentFile[0].name;
        } else {
          return "";
        }
      }
    },
    async mounted() {
      const {companyLogo} = await getCompanyLogo()
      this.companyLogo = companyLogo
    }
  }
</script>
